import { useEffect, useState } from "react";

import { UserService } from "../../../../services/UserService";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function Recommended() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  const pageNumber = 1;
  const pageSize = 1000;
  const [users, setUsers] = useState([]);
  const userSearch = { orderby: "nickname", order: 0 };
  useEffect(
    () =>
      UserService.getAllUsers(pageSize, pageNumber, userSearch).then((data) =>
        setUsers(data.users)
      ),
    []
  );
  return (
    <fieldset>
      <legend>{t("Recommended")}</legend>
      <select
        className="form-select"
        onChange={onChange}
        value={searchObject.recommended || ""}
        name="recommended"
      >
        <option value=""></option>
        {users.map((user) => (
          <option value={user.id}>{t(user.nickname)}</option>
        ))}
      </select>
    </fieldset>
  );
}
